import { render, staticRenderFns } from "./PageBottom.vue?vue&type=template&id=cf7472d0&scoped=true&"
import script from "./PageBottom.vue?vue&type=script&lang=js&"
export * from "./PageBottom.vue?vue&type=script&lang=js&"
import style0 from "./PageBottom.vue?vue&type=style&index=0&id=cf7472d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7472d0",
  null
  
)

export default component.exports